module.exports = function()
{
    this.id = "";
    this.name = "";
    this.func = null;
    this.noOfMaximumExecutions = 0;
    this.noOfCurrentExecutions = 0;

    this.onFailure = null;
    this.onSuccess = null;
}